import { createStyles, makeStyles, Tab, Tabs, Theme } from '@material-ui/core';
import React, { useState } from 'react';

import { AnalyticsOneItemFragment } from '../../../../graphql/gen/types';
import { UsersList } from './UsersList';

type Props = {
  data?: AnalyticsOneItemFragment | null;
};

export function AnalyticsTabs({ data }: Props): React.ReactElement {
  const classes = useStyles();

  const [selectedTab, setSelectedTab] = useState(0);

  const handleChange = (event: React.ChangeEvent<unknown>, selectedTab: number): void => {
    setSelectedTab(selectedTab);
  };

  return (
    <div className={classes.root}>
      <Tabs value={selectedTab} onChange={handleChange}>
        <Tab label={`Audience (${data?.audience})`} />
        <Tab label={`Unique Impressions (${data?.impressions})`} />
        <Tab label={`Unique Clicks (${data?.clicks})`} />
        <Tab label={`Comments (${data?.commentsCount})`} disabled={true} />
        <Tab label={`Reactions (${data?.reactionsCount})`} disabled={true} />
      </Tabs>
      {selectedTab === 0 && <UsersList users={data?.audienceBy || []} />}
      {selectedTab === 1 && <UsersList users={data?.impressionsBy || []} />}
      {selectedTab === 2 && <UsersList users={data?.clicksBy || []} />}
    </div>
  );
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
    },
  })
);
